// Vendors
import { viewportWidth } from '@openbank/cf-ui-framework';
// Constants
import {
  CANCEL_DROP_MODAL_MAX_WIDTH,
  CANCEL_DROP_MODAL_MOBILE_BREAKPOINT_WIDTH,
} from '../constants/cancel-drop-modal.constants';

const getModalMaxWidth = (): string | undefined =>
  viewportWidth() >= CANCEL_DROP_MODAL_MOBILE_BREAKPOINT_WIDTH
    ? CANCEL_DROP_MODAL_MAX_WIDTH
    : undefined;

export { getModalMaxWidth };
